import {
  createApi,
  fetchBaseQuery,
} from '@reduxjs/toolkit/query/react';

import { setCredentials } from '../components/core/auth/authSlice';

/**
 * Create base query with credentials and headers
 * shall only have one instance for the entire api except auth
 * auth is managed by authApiSlice and authSlice only
 */
const baseQuery = fetchBaseQuery({
  baseUrl: '/api',
  credentials: 'include',
  headers: {
    'Content-Type': 'application/json',
  },
});

/**
 *  Base Query Authentication for setting credentials
 */
const baseQueryAuth = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions);
  if (result?.data?.token) {
    api.dispatch(
      setCredentials({
        ...result.data,
      })
    );
  }

  return result;
};

/**
 * createApi() - creates api slice
 */
export const apiSlice = createApi({
  baseQuery: baseQueryAuth,
  tagTypes: [
    'AppModuleRef',
    'AppSetting',
    'AssetGroup',
    'AssetPart',
    'AssetRecall',
    'Contact',
    'Department',
    'DeptFacility',
    'Employee',
    'Facility',
    'FacilityAsset',
    'FacilityAssetCharterLog',
    'FacilityAssetCharterRef',
    'FacilityCategory',
    'FacilityCategoryList',
    'GroupRole',
    'Incident',
    'IncidentTypeRef',
    'MaintenanceLog',
    'ModulePermission',
    'OrgAppSetting',
    'OrgCategory',
    'OrgCategoryList',
    'ParentCategoryList',
    'OrgGroup',
    'OrgPycubeAssets',
    'OrgRole',
    'OrgSubscription',
    'OrgUser',
    'Organization',
    'OrganizationList',
    'UserList',
    'Product',
    'ProductAttachment',
    'ProductDetail',
    'ProductsList',
    'PycubeProduct',
    'PycubeProductType',
    'Recall',
    'RecallsList',
    'RecallType',
    'RolePermission',
    'StateRef',
    'StatusRef',
    'Ticket',
    'TicketAsset',
    'TicketCategoryRef',
    'TicketPriorityRef',
    'UiModule',
    'UserAudit',
    'UserFacility',
    'UserGroup',
    'UserOrganization',
    'UserPermission',
    'UserRole',
    'Vendor',
    'VendorsList',
    'AuditLogsList',
    'DepartmentsFacilities',
    'FacilityProduct',
    'FacilityProductList',
    'FacilityAssetsList',
    's3Files',
    'OrgRoleList',
    'ProfileSettings',
  ],
  refetchOnMountOrArgChange: true,
  endpoints: builder => ({}),
});
